export enum EnumInsurancePreference {
  LOCATION = 'location',
  SKIP = 'skip',
  REQUEST = 'request',
}

export interface AppointmentType {
  id: string
  name: string
  price: string
  duration: number
  description: string
  isVirtual: boolean
  insurancePreference: EnumInsurancePreference
}
